/**
 * Determines the shellfish text based on variant title
 * @param {string} variantTitle - The title of the variant
 * @returns {string} - Returns 'shellfish-free', 'with shellfish', or empty string
 */
export const getShellfishText = (variantTitle) => {
  if (!variantTitle) return ''
  const title = variantTitle.toLowerCase().trim()

  if (title.includes('no shellfish') || title.includes('shellfish-free')) {
    return 'Shellfish-free'
  }
  if (title.includes('shellfish')) {
    return 'With shellfish'
  }
  return ''
}
